<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="insiderName"
    type="text"
    placeholder="Search by insider name"
    class="border-b text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'insiderName')"
  />
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="issuerName"
    type="text"
    placeholder="Search by issuer name"
    class="border-b text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'issuerName')"
  />
</div>

<div class="mb-4"></div>
<div>
  <p-table
    [value]="unReferencedInsiders"
    [paginator]="unReferencedInsiders.length > 0"
    [rows]="paginator.pageSize"
    (onLazyLoad)="loadData($event)"
    [lazy]="true"
    [first]="First"
    [totalRecords]="paginator.totalCount"
    [loading]="isLoading"
    [(selection)]="selectedInsiders"
    dataKey="insiderUnreference"
    [showCurrentPageReport]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    (onPage)="pageChange($event)"
    [rowsPerPageOptions]="[10, 25, 50]"
  >
    <ng-template #header>
      <tr>
        <th>A R C. Id</th>
        <th>Insider Name</th>
        <th>Issuer Name</th>

        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template #body let-product>
      <tr>
        <td>
          {{ product.asReportedInsiderId || "N/A" }}
        </td>

        <td>{{ product.asReportedInsiderName || "N/A" }}</td>
        <td>{{ product.asReportedIssuerName || "N/A" }}</td>

        <td>
          <button
            class="text-red-600 hover:text-red-400 px-3 py-1 rounded flex items-center gap-2 cursor-pointer"
            (click)="onDeleteClick(product)"
          >
            <i class="pi pi-trash"></i>
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #noData>
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-template>
<p-confirmDialog></p-confirmDialog>
